import React, { Component } from 'react';

import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import { assetStatus } from 'components/shared/MaintenanceStatuses';

const assetStatuses = [
  'Healthy',
  'Service Due',
  'WO Outstanding',
  'Broken',
  'Replace',
  'Offline',
  'Inactive',
];

class AssetTableStatusMenu extends Component {
  render() {
    const { anchorEl, handleClose, changeStatus, currentStatus } = this.props;

    return (
      <Menu id="simple-menu" anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        {assetStatuses.map((statusName, index) => (
          <MenuItem
            onClick={() => changeStatus(statusName)}
            disabled={statusName === currentStatus}
            selected={statusName === currentStatus}
            key={index}
          >
            <span>{assetStatus(statusName)}</span>
          </MenuItem>
        ))}
      </Menu>
    );
  }
}

export default AssetTableStatusMenu;
